import { PanelContentContainer } from '../styles'
import { InviteeDetailsSection } from './invitee_details_section'
import { InviteeGuestsQuestion } from './invitee_guests_question'
import { InviteeQuestionsSection } from './invitee_questions_section'
import { LocationQuestionSection } from './location_question_section'
import { LockedInviteeQuestionsSection } from './locked_invitee_questions_section'
import { TextMessageSection } from './text_message_section'

const InviteeFormLocked = ({ workflows }) => (
  <PanelContentContainer>
    <LockedInviteeQuestionsSection workflows={workflows} />
  </PanelContentContainer>
)

const InviteeFormSection = ({ workflows }) => (
  <PanelContentContainer>
    <InviteeDetailsSection />
    <InviteeGuestsQuestion />
    <TextMessageSection workflows={workflows} />
    <LocationQuestionSection />
    <InviteeQuestionsSection />
  </PanelContentContainer>
)

export const InviteeForm = ({ isLocked, ...props }) => (
  !isLocked ? <InviteeFormSection {...props} /> : <InviteeFormLocked {...props} />
)
